<template>
    <validation-observer ref="form" v-slot="{ meta, setValues }">
        <modal
            :id="modalId"
            title="Add Lock"
            scrollable
            ok-title="Save"
            :ok-disabled="!meta.valid || loading"
            @ok.prevent="save"
            @hide="hideModal"
        >
            <busy-modal :show="loading"></busy-modal>
            <b-row>
                <b-col>
                    <validation-provider name="lock_id" v-slot="{ errors }" rules="required|validInteger">
                        <form-input
                            label="eRentalLock Lock ID:"
                            v-model="values.lock_id"
                            :error="errors[0]"
                            @input="(val) => setValues({ lock_id: val })"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <validation-provider name="rental_property_id" v-slot="{ errors }" rules="required">
                        <form-select
                            label="Lodgix Property:"
                            v-model="values.rental_property_id"
                            :options="propertyOptions"
                            :error="errors[0]"
                            @input="(val) => setValues({ rental_property_id: val })"
                        ></form-select>
                    </validation-provider>
                </b-col>
            </b-row>
        </modal>
    </validation-observer>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import API from '../../../../api';
    import { DOOR_LOCKS_E_RENTAL_LOCK_LOCKS_ENDPOINT, DOOR_LOCKS_PROPERTIES_ENDPOINT } from '../../../../endpoints';
    import { formatResponseError } from '../../../../utils/api';
    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import FormInput from '../../../generic/form-input/form-input.vue';
    import FormSelect from '../../../generic/form-select/form-select.vue';
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        name: 'ERentalLockAddLockModalForm',
        components: {
            BusyModal,
            FormInput,
            FormSelect,
            Modal,
        },
        props: {
            modalId: String,
        },
        mounted() {
            (async () => {
                this.loading = true;
                try {
                    await this.fetchProperties();
                } finally {
                    this.loading = false;
                }
            })();
        },
        computed: {
            propertyOptions() {
                return [
                    { text: 'Not Selected', value: null },
                    ...this.properties.map((property) => ({
                        text: property.name,
                        value: property.id,
                    })),
                ];
            },
        },
        data() {
            return {
                loading: false,
                properties: [],
                values: {
                    lock_id: null,
                    rental_property_id: null,
                },
            };
        },
        methods: {
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            async fetchProperties() {
                try {
                    const response = await API.get(DOOR_LOCKS_PROPERTIES_ENDPOINT());
                    this.properties = response.data;
                } catch {
                    this.errorToast({ text: 'Could not load properties.' });
                }
            },
            async save() {
                this.loading = true;

                try {
                    await API.post(DOOR_LOCKS_E_RENTAL_LOCK_LOCKS_ENDPOINT(), this.values);
                    this.$emit('success-save');
                    this.$nextTick(() => {
                        this.hideModal();
                    });
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!generic && !isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
